import React from "react";
import Login from "../layouts/Login";



const login = () => {
  return (
    <div>
      <Login />
    </div>
  );
};

export default login;



